module.exports = __webpack_public_path__ + "img/icon-reload.2cb5f7fe.svg";